import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import { type JSX, Show } from "solid-js";
import { Box } from "styled-system/jsx";

export default function Header(props: {
  title?: string;
  leftContent?: JSX.Element;
  subTitle?: JSX.Element | string;
  rightContent?: JSX.Element;
}) {
  return (
    <Box display='flex'
      alignItems='center'
      justifyContent='space-between'
      py={{
        base: '3',
        mdDown: '1.5'
      }}
      pt={{
        base: '3',
        mdDown: '0'
      }}
      px={{
        base: '6',
        mdDown: '3'
      }}>

      <Box display='grid' alignContent='center'>
        <Show when={props.title} fallback={props.leftContent}>
          <Heading textTransform='capitalize' textStyle='xl'>{props.title}</Heading>
        </Show>

        <Show when={props.subTitle}>
          <Text>{props.subTitle}</Text>
        </Show>
      </Box>

      {props.rightContent}
    </Box>
  )
}
